import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

const TabNavigation = ({ children }) => {
  return (
    <div className="px-4 border-b border-gray-100 pb-3 w-full flex mt-4 whitespace-nowrap overflow-x-auto">
      <nav className="flex gap-x-4 items-start order-2 lg:order-1">
        {children}
      </nav>
    </div>
  );
};

const NavLink = ({ to, children }) => (
  <RouterNavLink
    to={to}
    className={`p-0 m-0 border-b-2 border-transparent transition-colors focus:outline-none focus:border-chocolate-600 ring-0 font-medium hover:text-chocolate-600`}
    activeClassName="border-chocolate-600 text-chocolate-600"
  >
    {children}
  </RouterNavLink>
);

TabNavigation.NavLink = NavLink;

export default TabNavigation;
